<template>
  <section class="get-quote">
    <v-container class="mx-auto">
      <h2 class="pt-10 get-quote-title">{{ getPrice.mainTitle }}</h2>
      <div class="campaign-data-table">
        <v-row class="mt-10">
          <v-col
            cols="12"
            md="5"
            lg="5"
            xl="5"
            class="pt-md-2 pt-lg-10 data-table--right"
          >
            <h3 class="campaign-data-table--heading head-1 mb-4">
              {{ priceContent.upper.title }}
            </h3>
            <p class="campaign-data-table-text">
              {{ priceContent.upper.desc }}
            </p>
            <h3 class="campaign-data-table--heading head-2 mb-4">
              {{ priceContent.middle.title }}
            </h3>
            <p class="campaign-data-table-text">
              {{ priceContent.middle.desc }}
            </p>
            <h3 class="campaign-data-table--heading head-3 mb-4">
              {{ priceContent.bottom.title }}
            </h3>
            <p class="campaign-data-table-text">
              {{ priceContent.bottom.desc }}
            </p>
            <v-btn
              @click="scrollTop"
              elevation="2"
              color="success"
              class="mt-15 data-table--button"
              large
            >
              Hemen Teklif Al
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7" class="data-table--left">
            <template>
              <v-simple-table height="480" class="data-table--container">
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="item in getPrice.campaigns"
                      :key="item.id"
                      class="data-table--row"
                    >
                      <td class="data-table--row__item">
                        <v-img
                          width="100px"
                          :src="item.company"
                          :alt="item.alt"
                        >
                        </v-img>
                      </td>
                      <td class="data-table--row__item item-name">
                        {{ item.name }} <br />
                        <span class="item-subname">{{ item.assurance }}</span>
                      </td>
                      <td class="data-table--row__item item-price">
                        {{ item.desc }}<br />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    getPrice: {
      type: Object,
      require: true
    },
    getPriceContent: {
      type: Object,
      require: false
    }
  },
  data () {
    return {}
  },
  methods: {
    scrollTop () {
      window.scrollTo(0, 0)
    }
  },
  computed: {
    priceContent () {
      if (this.getPriceContent) return this.getPriceContent
      return {
        upper: {
          title: 'Bilgilerinizi Doldurun',
          desc:
            'Bize biraz kendinizden bahsedin. Bilgilerinizi doldurun ve anında en yüksek puan alan sigortacılardan sigorta poliçesi prim teklifleri alın.'
        },
        middle: {
          title: 'Teklifleri Karşılaştırın ve Bir Sigorta Poliçesi Seçin',
          desc:
            'Çok sayıda mevcut fiyat teklifi arasından gereksinimlerinize ve bütçenize en uygun olanı seçin.'
        },
        bottom: {
          title: 'Ödeme Yapın ve Arkanıza Yaslanın',
          desc: 'Online ödeme yapın ve poliçenizi hemen gelen kutunuzdan alın.'
        }
      }
    }
  }
}
</script>
